import { Directive, TemplateRef } from '@angular/core';

/**
 * Маркер шаблона заголовка для app-ui-table.
 * Используется так:
 *   <app-ui-table>
 *     <ng-template appUiTableHeader let-table="table">
 *       <tr>
 *         <th>...</th>
 *       </tr>
 *       <!-- строка фильтров, если нужна -->
 *       <tr>
 *         <td><input (input)="table.filter(...)" /></td>
 *       </tr>
 *     </ng-template>
 *   </app-ui-table>
 *
 * Контекст шаблона:
 *   table -> инстанс p-table (для tt.filter() и т.п.)
 */
@Directive({
  selector: '[appUiTableHeader]',
  standalone: true
})
export class UiTableHeaderDirective {
  constructor(public template: TemplateRef<any>) {}
}
